// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export function usePublishPermissions() {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    /**
     * Permissions
     */
    var canReadPublish = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_READ);
    var canWritePublish = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_WRITE);
    var canPublishCreate = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_CREATE);
    var canPublishRegenerate = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_REGENERATE);
    var canPublishExport = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_EXPORT);
    var canPublishStartVoting = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_START_VOTING);
    var canPublishPauseVoting = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_PAUSE_VOTING);
    var canPublishStopVoting = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_STOP_VOTING);
    var canPublishChanges = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_CHANGES);
    var showPublishColumns = authContext.isAuthorized(true, tenantId, IPermissions.EE_PUBLISH_COLUMNS);
    var showPublishFilters = authContext.isAuthorized(true, tenantId, IPermissions.EE_PUBLISH_FILTERS);
    var showPublishView = authContext.isAuthorized(true, tenantId, IPermissions.EE_PUBLISH_VIEW);
    var showPublishPreview = authContext.isAuthorized(true, tenantId, IPermissions.EE_PUBLISH_PREVIEW);
    var showPublishButtonBack = authContext.isAuthorized(true, tenantId, IPermissions.EE_PUBLISH_BACK_BUTTON);
    /**
     * Permissions
     */
    return {
        canReadPublish: canReadPublish,
        canWritePublish: canWritePublish,
        canPublishCreate: canPublishCreate,
        canPublishRegenerate: canPublishRegenerate,
        canPublishExport: canPublishExport,
        canPublishStartVoting: canPublishStartVoting,
        canPublishPauseVoting: canPublishPauseVoting,
        canPublishStopVoting: canPublishStopVoting,
        canPublishChanges: canPublishChanges,
        showPublishPreview: showPublishPreview,
        showPublishView: showPublishView,
        showPublishButtonBack: showPublishButtonBack,
        showPublishColumns: showPublishColumns,
        showPublishFilters: showPublishFilters,
    };
}
